export const createVariableString = (type: string, name: string, fallback?: string) => {
  return `{{${type}.${name}${fallback && fallback.length > 0 ? `|${fallback}` : ''}}}`;
};

export const parseProviders = (href?: string) => {
  if (!href) {
    return [];
  }
  const matches = href.matchAll(/{{([a-zA-Z0-9.\-_]+)}}/g);
  return [...matches]
    .map((match) => {
      return match.length > 1 ? match[1] : undefined;
    })
    .filter((provider) => !!provider) as string[];
};

const userMatches = (href: string) => {
  // user followed by any string that is not a pipe or closing bracket
  // e.g. {{user.name}}
  const matches = href.matchAll(/{{user\.([^|}]*)\|?([^}]*)}}/g);
  return [...matches].map((match) => {
    const name = match[1];
    const fallback = match[2];
    return { type: 'user', name, fallback };
  });
};

const urlMatches = (href: string) => {
  const matches = href.matchAll(
    /{{url\.(pathname|search|protocol|hostname)(\[[^|[]+])?(\|[^}]*)?}}/g,
  ); // url followed by a known pathname, optionally followed by an interger inside square brackets, optionally followed by a pipe and a fallback
  // e.g. {{url.pathname[0]|fallback}}
  return [...matches].map((match) => {
    const name = match[1] + (match[2] || '');
    // strip leading | from fallback
    const fallback = match[3]?.substring(1);
    return { type: 'url', name, fallback };
  });
};

export const parseVariables = (href?: string) => {
  if (!href) {
    return [];
  }
  return [...userMatches(href), ...urlMatches(href)];
};

export const stringWithFallbacks = (href?: string): string => {
  if (!href) {
    return '';
  }

  let res = href;

  // @ts-ignore
  res = res.replaceAll(
    /{{user\.([^|}]*)\|?([^}]*)}}/g,
    (match: string, name: string, fallback: string) => {
      if (fallback) {
        return fallback;
      }
      return `{{user.${name}}}`;
    },
  );

  // @ts-ignore
  res = res.replaceAll(
    /{{url\.([^|}]*)\|?([^}]*)}}/g,
    (match: string, name: string, fallback: string) => {
      if (fallback) {
        return fallback;
      }
      return `{{url.${name}}}`;
    },
  );

  return res;
};
